<template>
  <div>
    <b-container fluid>
      <b-row>
        <b-col cols="12" lg="6">
          <h2>Novo usuário</h2>

          <b-alert v-model="f.show" :variant="f.variant" dismissible>
            {{ f.msg }}

            <div v-if="user.pass !== ''">
              <hr>
              <p>
                Login: <strong class="text-monospace">{{ user.login }}</strong>
                <br>
                Senha: <strong class="text-monospace">{{ user.pass }}</strong>
              </p>
            </div>
          </b-alert>

          <b-form @submit="onSubmit" class="mb-4">
            <b-form-group
              label="CPF:"
              label-for="input-login"
              description="Informe o CPF"
            >
              <b-form-input
                id="input-login"
                v-model="form.login"
                type="text"
                v-mask="'###.###.###-##'"
                required
                :autofocus="true"
              ></b-form-input>
            </b-form-group>

            <b-form-group
              label="Nome:"
              label-for="input-name"
              description="Informe o nome completo"
            >
              <b-form-input
                id="input-name"
                v-model="form.name"
                type="text"
                required
              ></b-form-input>
            </b-form-group>

            <b-button type="submit" variant="primary">Criar</b-button>
          </b-form>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  name: 'AdminUsersNew',
  data () {
    return {
      form: {
        login: '',
        name: '',
        role: 'organizer'
      },
      f: {
        variant: 'danger',
        msg: '',
        show: false
      },
      user: {
        login: '',
        pass: ''
      }
    }
  },
  methods: {
    async onSubmit (evt) {
      evt.preventDefault()
      try {
        let resp = await this.$http.post(process.env.VUE_APP_URL_APP + '/b/admin/users', this.form)

        this.user.login = this.form.login
        this.user.pass = resp.body.pass

        this.f = {
          msg: 'Usuário criado!',
          variant: 'success',
          show: true
        }

        this.form.login = ''
        this.form.name = ''
      } catch (err) {
        this.user.pass = ''

        this.f = {
          msg: err.body.message,
          show: true,
          variant: 'danger'
        }
      }
    }
  }
}
</script>
